
import React from 'react';
import NavigationBar from '../components/NavigationBar';
import Footer from '../components/Footer/Footer';
import Menus from '../components/Menus';
import { useTranslation } from 'react-i18next';
import { useResto } from '../contexts/RestoContext';
import MediaList from '../components/MediaList';

const CGU = () => {
  const { t } = useTranslation();
  const { restoData } = useResto();

  return (
    <div>
      <NavigationBar />
      <div className="p-3">
        <h1>{ t('TERMS_OF_USE') }</h1>

        <h2>Article 1 - Objet</h2>

        <p>Les présentes conditions générales d'utilisation (ci-après les "CGU") ont pour objet de définir les règles et conditions applicables à l'utilisation du site web www.{ restoData.website }.{ restoData.extension } (ci-après le "Site").</p>

        <h2>Article 2 - Définitions</h2>

        <ul>
          <li>**Utilisateur** : Toute personne physique ou morale qui accède et utilise le Site.</li>
          <li>**Contenu** : Ensemble des éléments constituant le Site, notamment les textes, images, vidéos, sons, et bases de données.</li>
          <li>**Propriétaire** : La personne physique ou morale titulaire des droits de propriété intellectuelle sur le Contenu du Site.</li>
        </ul>

        <h2>Article 3 - Accès et utilisation du Site</h2>

        <p>L'accès au Site est libre et gratuit. L'Utilisateur s'engage à utiliser le Site de manière conforme aux présentes CGU et aux lois et règlements en vigueur.</p>

        <h2>Article 4 - Propriété intellectuelle</h2>

        <p>Le Contenu du Site est protégé par les droits de propriété intellectuelle du Propriétaire. L'Utilisateur s'engage à ne pas reproduire, copier, modifier, diffuser, ou exploiter de quelque manière que ce soit le Contenu du Site sans l'autorisation expresse et écrite du Propriétaire.</p>

        <h2>Article 5 - Responsabilité</h2>

        <p>Le Propriétaire ne peut être tenu responsable des dommages directs ou indirects, matériels ou immatériels, causés par l'utilisation du Site ou de son Contenu.</p>

        <h2>Article 6 - Liens hypertextes</h2>

        <p>Le Site peut contenir des liens hypertextes vers d'autres sites web. Le Propriétaire ne peut être tenu responsable du contenu de ces sites web.</p>

        <h2>Article 7 - Modification des CGU</h2>

        <p>Le Propriétaire se réserve le droit de modifier les présentes CGU à tout moment. Les modifications entreront en vigueur dès leur publication sur le Site.</p>

        <h2>Article 8 - Loi applicable et juridiction compétente</h2>

        <p>Les présentes CGU sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.</p>

        <h2>Article 9 - Contact</h2>

        <p>Pour toute question ou réclamation, l'Utilisateur est invité à utiliser le formulaire de contact disponible sur le Site.</p>

        <h2>Article 10 - Inscription et création d'un compte</h2>

        <p>L'Utilisateur peut créer un compte sur le Site en remplissant un formulaire d'inscription et en choisissant un mot de passe.</p>

        <p>L'Utilisateur est responsable de la sécurité de son compte et de son mot de passe.</p>

        <h2>Article 11 - Politique de confidentialité</h2>

        <p>Le Propriétaire collecte des données personnelles lors de l'inscription de l'Utilisateur, de la passation d'une commande et de la navigation sur le Site.</p>

        <p>Les données collectées sont les suivantes : nom, prénom, adresse email, adresse postale, numéro de téléphone, données de connexion et de navigation.</p>

        <p>Le Propriétaire s'engage à ne pas transmettre les données collectées à des tiers sans le consentement de l'Utilisateur.</p>

        <p>L'Utilisateur dispose d'un droit d'accès, de rectification, de suppression et d'opposition aux données le concernant.</p>

        <h2>Article 12 - Cookies</h2>

        <p>Le Site utilise des cookies pour améliorer l'expérience utilisateur et à des fins de statistiques.</p>

        <p>L'Utilisateur peut accepter ou refuser l'utilisation des cookies.</p>

        <p>L'Utilisateur peut paramétrer son navigateur pour refuser l'installation de cookies.</p>

        </div>

        <MediaList mediaKey='CGU_BOTTOM' maxItems={1} isShortLine={true} />
      <Menus />
      <Footer />
    </div>
  );
}

export default CGU;